
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Main_Data_time","data-name":"Main Data time","transform":"translate(-100.665 -539.151)"}},[_c('rect',{attrs:{"id":"Rectangle_9038","data-name":"Rectangle 9038","width":"14","height":"14","transform":"translate(100.665 539.151)","fill":"none"}}),_c('g',{attrs:{"id":"Group_29617","data-name":"Group 29617","transform":"translate(102.191 540.677)"}},[_c('g',{attrs:{"id":"Group_29620","data-name":"Group 29620","transform":"translate(.315 .315)","fill":"none","stroke":"#97a0ae","stroke-linecap":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"Path_20976","data-name":"Path 20976","d":"M5.646 10.817A5.159 5.159 0 10.5 5.674a5.167 5.167 0 005.146 5.143z","transform":"translate(-.5 -.5)"}}),_c('path',{attrs:{"id":"Path_20977","data-name":"Path 20977","d":"M7 3.111v3.207l1.41 1.19","transform":"translate(-1.842 -.961)","stroke-linejoin":"round"}})])])])])
          )
        }
      }
    